import {FormGroup} from '@angular/forms';

export function pickFormValues(keys: string[], formGroup: FormGroup): Record<string, unknown> {
  return Object.fromEntries(
    keys.map((key) => [key, formGroup.get(key)?.value]),
  );
}
